'use client';

import CartIcon from '@/components/icons/cart';
import { addItemToCart } from '@/services/cart';
import { setCookie, getCookies } from 'cookies-next';
import useCheckout from '@/store/checkout.store';
import { useLocale, useTranslations } from 'next-intl';
import useCart from '@/store/cart.store';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/buttons';
import {
  event_add_to_cart,
  event_error_boundry,
  update_cart_event,
} from '@/utils/gtm';
import NotifyMeIcon from '../icons/notify-me-icon';
import { useSession } from 'next-auth/react';
import { notifyMeV2 } from '@/services/product';
import AuthModal from '../modals/auth-modal';
import useAppData from '@/store/app.store';

const AddToCart = ({
  qty = 1,
  product,
  fromCartPopUp,
  isFromWishList,
  isFromPDP,
}) => {
  const locale = useLocale();
  const [loading, setLoading] = useState(false);
  const t = useTranslations('common');
  const cart = useCart((store) => store);
  const clearCheckout = useCheckout((state) => state.clearCheckout);
  const { data: session } = useSession();
  const [auth, setAuth] = useState(false);
  const store = useAppData((state) => state);
  const isInStock =
    product?.pg_stock?.is_in_stock && product?.pg_stock?.qty >= 1;
  const isNotifiedBefore =
    store?.notifyProducts?.findIndex(
      (info) => info?.sku === product?.sku && session?.user?.id === info?.userId
    ) !== -1;
  const handleAddToCart = async () => {
    setLoading(true);

    const { quote, mage } = getCookies();
    const res = await addItemToCart({ sku: product?.sku, qty, quote, mage });
    let productFeesFromCart = [];
    if (res?.status === 200) {
      if (quote !== res?.data?.quoteId) {
        cart.resetCart();
        clearCheckout();
        setCookie('quote', res?.data?.quoteId);
        // setLoading(false);

        // return;
      }

      // const relInfo = await getRelatedInfo(product?.sku);
      // if (relInfo?.data?.[0]?.product_fees?.length > 0) {
      //   productFeesFromCart = relInfo?.data?.[0]?.product_fees;
      //   const requiredOption = productFeesFromCart?.find(
      //     (info) => info?.required === '1'
      //   );
      //   const option = Object.entries(requiredOption?.options || {}).find(
      //     (info) => info?.[1]?.is_default === '1'
      //   );
      //   const defaultFees = [
      //     {
      //       [option?.[0]]: {
      //         id: option?.[1]?.fee_id,
      //         options: option?.[1]?.fee_option_id,
      //       },
      //     },
      //   ];
      //   await addProductFees(res?.data?.data?.item_id, defaultFees);
      // }

      cart?.addItem({
        ...product,
        ...res?.data?.data,
        qty: res?.data?.data?.qty,
        productFeesFromCart,
      });

      event_add_to_cart(product, qty, 'add_to_cart');
      // check if item exist don't add it, else add it
      const cart_updated_event_items = !cart?.cartItems.find(
        (info) => info?.sku === product?.sku
      )
        ? cart?.cartItems?.concat({ ...product, qty })
        : cart?.cartItems
            .filter((info) => info?.sku !== product?.sku)
            .concat({ ...product, qty });
      update_cart_event(cart_updated_event_items);
      toast.success(t(res?.data?.message || 'Item Added To Cart succssfully'));
      !fromCartPopUp ? cart?.togglePopup() : null;
      setLoading(false);
    } else {
      toast.error(
        t(res?.error?.error?.message?.replaceAll('.', '') || 'ErrorAddToCart')
      );
      event_error_boundry(
        t(res?.error?.error?.message?.replaceAll('.', '') || 'ErrorAddToCart'),
        'Back End Issue'
      );
      setLoading(false);
    }
  };

  const handleNotifyMe = async () => {
    if (session?.user?.id) {
      setLoading(true);

      const res = await notifyMeV2(
        product?.entity_id,
        session?.user?.id,
        locale
      );
      if (res?.status === 200 && res?.data?.data?.[0]?.error === false) {
        toast.success(t('Alert subscription has been saved for this product'));
        store.setNotifyProducts(product?.sku, session?.user?.id);
      } else {
        toast.error(res?.data?.data?.[0]?.message);
      }
      setLoading(false);
    } else {
      setAuth('login-mobile');
    }
  };

  if (isFromWishList) {
    return (
      <>
        <button
          onClick={isInStock ? handleAddToCart : handleNotifyMe}
          disabled={loading || isNotifiedBefore}
          className='mt-2 flex size-9 cursor-pointer items-center justify-center rounded-sm bg-white shadow disabled:cursor-not-allowed max-sm:size-6'
        >
          {loading ? (
            <span className='size-5 animate-spin rounded-full border-t border-r border-black font-bold' />
          ) : isInStock ? (
            <CartIcon className='size-6 max-lg:size-5 max-md:size-4.25 max-sm:size-3.5' />
          ) : !isNotifiedBefore ? (
            <NotifyMeIcon className='size-6 max-lg:size-5 max-md:size-4.25 max-sm:size-3.5' />
          ) : (
            <NotifyMeIcon className='text-primary size-6 max-lg:size-5 max-md:size-4.25 max-sm:size-3.5' />
          )}
        </button>
        {!!auth ? <AuthModal auth={auth} setAuth={setAuth} /> : null}
      </>
    );
  }

  if (isFromPDP) {
    return (
      <>
        <Button
          className={`flex w-full ${isInStock ? '' : '!bg-[#7B7B7B] hover:!bg-[#7B7B7B]/70'} items-center gap-4 max-md:text-sm max-sm:fixed max-sm:end-2 max-sm:bottom-23 max-sm:z-500 max-sm:max-w-[205px] max-sm:gap-2 max-sm:text-xs`}
          disabled={loading || isNotifiedBefore}
          onClick={isInStock ? handleAddToCart : handleNotifyMe}
        >
          {loading ? (
            <span className='size-4 animate-spin rounded-full border-t border-r border-white font-bold' />
          ) : null}
          {isInStock ? (
            t('add_to_cart_key')
          ) : !isNotifiedBefore ? (
            <>
              <NotifyMeIcon className='size-5 max-md:size-4.25 max-sm:size-3.5' />
              {t('Notify Me')}
            </>
          ) : (
            <>
              <NotifyMeIcon className='text-primary size-5 max-md:size-4.25 max-sm:size-3.5' />
              {t('Notified Before')}
            </>
          )}
        </Button>
        {!!auth ? <AuthModal auth={auth} setAuth={setAuth} /> : null}
      </>
    );
  }

  return (
    <>
      <button
        onClick={isInStock ? handleAddToCart : handleNotifyMe}
        disabled={loading || isNotifiedBefore}
        className='border-border flex size-6 cursor-pointer items-center justify-center rounded-sm border bg-white shadow disabled:cursor-not-allowed max-md:shadow lg:size-7'
      >
        {loading ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-black font-bold disabled:cursor-not-allowed' />
        ) : isInStock ? (
          <CartIcon className='size-5 max-md:size-4.25 max-sm:size-3.5' />
        ) : !isNotifiedBefore ? (
          <NotifyMeIcon className='size-5 max-md:size-4.25 max-sm:size-3.5' />
        ) : (
          <NotifyMeIcon className='text-primary size-5 max-md:size-4.25 max-sm:size-3.5' />
        )}
      </button>
      {!!auth ? <AuthModal auth={auth} setAuth={setAuth} /> : null}
    </>
  );
};

export default AddToCart;
